import React from 'react'
import CartPage from '../../components/Client/Cart/CartPage'

const Cart = () => {
  return (
    <div>
      <CartPage/>
      
    </div>
  )
}

export default Cart
